export default __webpack_public_path__ + "static/webRotator/svg/ff00eb1c2e7492655010a533b7a22421.svg";